import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DataLoader from "../../../Utils/DataLoader";
import { apiData } from "../../../actions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Modal } from "react-bootstrap";

export default function Tours() {
    const place = useSelector((state) => state.place);
    const localSelectedCity = localStorage.getItem("selectedCity");
    const formattedCity =
        place?.replace(/\b\w/g, (x) => x.toUpperCase()) || "";

    const [tour, setTour] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [seeMoreModal, setSeeMoreModal] = useState(false);


    const getTourDeals = async () => {
        let payload = {
            city: place,
            limit: 5,
        };

        try {
            setPageLoading(true);
            const apiRes = await apiData.get_Tour(payload);

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setTour(
                    apiRes?.data?.data?.data?.travelExperienceProducts?.resultList ||
                    []
                );
            }
        } catch (err) {
            console.error(err);
            setTour([]);
        } finally {
            setPageLoading(false);
        }
    };

    useEffect(() => {
        getTourDeals();
    }, [place]);

    if (pageLoading) return <DataLoader />;

    return (
        <section className="section-equal-padding top-spacing170 owl-nav-left">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div
                            className="section-top-heading mb-3 mb-md-5"
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                        >
                            <h2 className="mb-2 text-black">
                                {localSelectedCity && localSelectedCity !== "undefined"
                                    ? `Tours ${formattedCity}`
                                    : "Tours"}
                            </h2>
                            <p>
                                Save big on thrilling tours and sightseeing adventures! We've found Groupon deals for helicopter rides, bus tours, and more. Experience the best while keeping your wallet happy.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="">
                    {tour.length > 0 ? (
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            loop={true}
                            autoplay={{
                                delay: 3000,
                                disableOnInteraction: false,
                            }}
                            navigation={true}
                            breakpoints={{
                                0: { slidesPerView: 1 },
                                768: { slidesPerView: 2 },
                                992: { slidesPerView: 3 },
                                1400: { slidesPerView: 4 },
                            }}
                            className="excitement-swiper pb-70"
                        >
                            {tour.map((ele, index) => (
                                <SwiperSlide key={ele?.id || index} className="">
                                    <div
                                        className="resorts-box p-3 bg-white"
                                        // uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
                                    >
                                        <figure>
                                            <img
                                                loading="lazy"
                                                src={ele?.imageLink}
                                                className="img-fluid"
                                                alt={ele?.title}
                                            />
                                        </figure>

                                        <div className="resorts-content-box">
                                            <div className="d-flex justify-content-between align-items-center">
                                                {/* <span className="rating-star">
                                                    <i className="fa-solid fa-star"></i> 4.8 Overall Reviews
                                                </span> */}



                                            </div>

                                            <div className="resort-description">
                                                <h3>
                                                    {ele?.title?.length >= 20
                                                        ? `${ele?.title.slice(0, 20)}...`
                                                        : ele?.title}
                                                </h3>
                                                <p>{ele?.description?.length >= 20 ? `${ele?.description?.slice(0, 50)?.trim()}...` : ele?.description || ""}</p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="price-label">
                                                    {(ele?.price?.amount !== ele?.salePrice?.amount && ele?.price?.amount > ele?.salePrice?.amount) && (
                                                        <span className="old-price">${ele?.price?.amount}</span>
                                                    )}{" "}
                                                    <span>${ele?.salePrice?.amount}</span>
                                                </div>
                                                {(ele?.price?.amount !== ele?.salePrice?.amount && ele?.price?.amount > ele?.salePrice?.amount) && (
                                                    <span className="off-span">
                                                        {(() => {
                                                            const originalPrice = Number(ele?.price?.amount);
                                                            const salePrice = Number(ele?.salePrice?.amount);
                                                            const discount =
                                                                originalPrice && salePrice
                                                                    ? Math.max(0, Math.round(((originalPrice - salePrice) / originalPrice) * 100))
                                                                    : 0;
                                                            return `-${discount}%`;
                                                        })()}
                                                    </span>
                                                )}

                                                <div className="book-trip-btn">
                                                    <a className="flex flex-row" href={ele?.link} target="_blank" rel="noreferrer">
                                                        Book Trip <i className="fa-solid fa-arrow-right"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    ) : (
                        <p className="text-center py-4">
                            Oops! No Data Available {place && `For ${formattedCity}`}
                        </p>
                    )}

                    {/* <div className="d-flex justify-content-end mt-3">
                        <button className="view-all-btn" onClick={handleSeeAllClick}>
                            View All <i className="fa-solid fa-arrow-right"></i>
                        </button>
                    </div> */}
                </div>

            </div>

            <Modal
                show={seeMoreModal}
                onHide={() => setSeeMoreModal(false)}
                // backdrop="static"
                size="xl"
                className='modal_xl see-pop'
                keyboard={false}
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body id="beautifulCityAll">
                </Modal.Body>
            </Modal>
        </section>
    );
}
